import ModalPanel from '@admin/components/modal_panel'
import Message from '@admin/components/message'
import PropTypes from 'prop-types'
import React from 'react'

class Downloading extends React.Component {

  static contextTypes = {
    network: PropTypes.object
  }

  static propTypes = {
    timestamp: PropTypes.number,
    video: PropTypes.object,
    onDone: PropTypes.func
  }

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <Message { ...this._getMessage() } />
      </ModalPanel>
    )
  }

  componentDidMount() {
    this._handleDownload()
  }

  _getMessage() {
    return {
      svg: 'refresh_cw',
      spinning: true,
      title: 't(Extracting Keyframe)',
      text: 't(Please be patient while we extract this keyframe from your video)'
    }
  }

  _getPanel() {
    return {
      showHeader: false
    }
  }

  _handleDownload() {
    const { timestamp, video } = this.props
    this.context.network.request({
      endpoint: `/api/admin/assets/${video.asset.id}/keyframe`,
      method: 'POST',
      body: {
        timestamp
      },
      onSuccess: ({ data }) => {
        this.props.onDone({
          timestamp,
          asset: data
        })
      }
    })
  }

}

export default Downloading

